import React, { useEffect, useState } from "react";
import { Offcanvas, Dropdown, Spinner, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { addUserPortal, usersDropDown } from "../../redux/actions/portalAction";
import errorToast from "../../components/toast/errorToast";
import successToast from "../../components/toast/successToast";

const AssignUser = ({ show, onHide, portalId, reloadData }) => {
  const [usersData, setUsersData] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [loading, setloading] = useState(false)
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(usersDropDown({}, onSuccess, onError));
  }, []);

  const onSuccess = (data) => {
    setUsersData(data.data.data);
  };

  const onError = (data) => {
    setloading(false)
    errorToast(data.data.message);
  };

  const toggleDropdown = () => {
    setShowDropdown((prev) => !prev);
  };

  const handleUserSelect = (userId) => {
    setSelectedUsers((prevSelectedUsers) =>
      prevSelectedUsers.includes(userId)
        ? prevSelectedUsers.filter((id) => id !== userId)
        : [...prevSelectedUsers, userId]
    );
  };

  const handleAssign = () => {
    const data = {
      portal_id: portalId,
      users: selectedUsers
    };
    dispatch(addUserPortal(data, onAssignSuccess, onError));
    setloading(true)
  };

  const onAssignSuccess = (data) => {
    successToast(data.data.message);
    setloading(false)
    onHide();
    reloadData();
    setShowDropdown(false);
  };

  console.log(selectedUsers, "selectedUsers");

  return (
    <Offcanvas backdrop="static" show={show} onHide={onHide} placement="end" style={{ width: "600px" }}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Assign user to portal</Offcanvas.Title>
      </Offcanvas.Header>
      <hr />
      <Offcanvas.Body>
        <div>
          <h5>Select users</h5>
          <Dropdown show={showDropdown} onToggle={() => setShowDropdown(!showDropdown)}>
            <Dropdown.Toggle
              id="dropdown-basic"
              className="w-100 text-start text-white"
              onClick={toggleDropdown}
            >
              {selectedUsers.length > 0
                ? selectedUsers
                  .map((id) => usersData.find((user) => user.id === id)?.email)
                  .join(", ")
                : "Select users"}
            </Dropdown.Toggle>
            <Dropdown.Menu className="w-100">
              {usersData.map((user) => (
                <Dropdown.Item
                  key={user.id}
                  eventKey={user.id}
                  onClick={(e) => e.preventDefault()}
                  className="d-flex gap-2 align-items-center"
                >
                  <input
                    type="checkbox"
                    checked={selectedUsers.includes(user.id)}
                    onChange={() => handleUserSelect(user.id)}
                  />
                  <label onClick={() => handleUserSelect(user.id)}>{user.email}</label>
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div className={`d-flex gap-4 mt-4 px-4 ${showDropdown ? 'mt-2' : ''}`}>
          <button
            disabled={loading || selectedUsers.length < 1}
            type="submit" className="btn btn-primary btn-action d-flex text-nowrap cursor_pointer"
            style={{ minWidth: '80px' }}
            onClick={handleAssign}
          >
            <div className='fs_12 d-flex gap-2 justify-content-center cursor_pointer'>
              {loading ? <Spinner size="sm" className="mt-1" /> : ""}
              <label className="fs_16 cursor_pointer">{!loading ? 'Assign' : 'Assigning'}</label>
            </div>
          </button>
          <button type="button" className="btn btn-primary" onClick={onHide}>
            Cancel
          </button>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default AssignUser;

